import React from 'react';
import moment from 'moment';
import MonthGrid, { MonthGridDay, MonthGridMonth } from '@ui/calendar/MonthGrid';
import MarketRegionState from '@app/model/market_area/MarketAreaState';
import { marketRegionStateClusterNames } from '@app/model/market_area/MarketRegionStateCluster';
import { MarketPaceDay } from '@app/model/market_insight/MarketPace';
import { dayHoverHtml, PACE_VERDICT_LABEL } from './MarketPaceText';
import { CLUSTER_TONE } from './MarketPaceStyles';
import { paceDayOf } from './MarketDemandChartOptions';
import { PaceChip } from './PaceChip';

// The Calendar view of the demand panel (direction C): the design system MonthGrid. The demand gives
// the tone of each day, the pace gives the corner chip, the hover shows both. No today mark, as on the
// canvas: page 1 starts today, and today is the selected date by default.
type Props = {
	states: MarketRegionState[],
	pace: Map<string, MarketPaceDay> | null,
	months: MonthGridMonth[],
	selectedIndex: number,
	onSelect: (index: number) => void,
};

const MarketDemandCalendar: React.FunctionComponent<Props> = ({ states, pace, months, selectedIndex, onSelect }) => {
	const indexOf = new Map(states.map((state, i) => [state.statDate, i]));
	const days: MonthGridDay[] = states.map(state => {
		const day = pace === null ? undefined : paceDayOf(pace, state.statDate);
		const label = `${moment(state.statDate).format('D MMMM')}: demand ${marketRegionStateClusterNames[state.cluster]}`
			+ (day === undefined ? '' : `, ${PACE_VERDICT_LABEL[day.verdict]}`);
		return {
			date: state.statDate,
			label,
			toneClassName: CLUSTER_TONE[state.cluster],
			mark: day === undefined ? undefined : <PaceChip verdict={day.verdict} />,
			hoverHtml: dayHoverHtml(state, day),
		};
	});
	return <MonthGrid months={months} days={days}
		selected={states[selectedIndex]?.statDate}
		onSelect={date => {
			const i = indexOf.get(date);
			if (i !== undefined) onSelect(i);
		}} />;
};

export default MarketDemandCalendar;
